export default class OpportunityStageHistoryDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { createdDate: new Date(json.createdDate), fromStageEntryDate: new Date(json.fromStageEntryDate), fromStageExitDate: json.fromStageExitDate
                ? new Date(json.fromStageExitDate)
                : null });
    }
}
